import * as d3 from 'd3';
import { AnnotationModelItem, NumberData } from '../interfaces';

export const drawNumbering = function (wrapper, item: AnnotationModelItem) {
  const data: NumberData = item.data as NumberData;

  const w = d3.select(wrapper);
  const newG: d3.Selection<SVGElement, unknown, null, undefined> = w.select(`#item${item.id}`).node()
    ? w.select(`#item${item.id}`)
    : w.append('g');
  newG.selectAll('*').remove();
  newG.attr('vector-effect', 'non-scaling-stroke');
  newG
    .append('circle')
    .attr('r', '30')
    .attr('stroke', 'white')
    .style('stroke-width', 1)
    .attr('fill', data.color)
    .style('stroke-width', data.strokeWidth);

  newG
    .append('text')
    .attr('text-anchor', 'middle')
    .attr('alignment-baseline', 'middle')
    .attr('fill-opacity', 1)
    .attr('fill', 'black')
    .text(data.number.toString())
    .attr('style', 'user-select: none; font-size: 25px');
  return newG;
};
